
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as kartZMtmq6ddMObbkPbVkD2IJXauCN7gN3wEReY2s5fTW_45oMeta } from "/home/bede/bede-web/pages/kart.vue?macro=true";
import { default as index2CIlIrOxq503fvSu3PxV_45_DFiDfsFhv79tl9ureA_45esMeta } from "/home/bede/bede-web/pages/index.vue?macro=true";
import { default as om_45osstMU_ry3u9EOnhexjSn5bfIhqH7XFjdFK7yt6F9VPSOQMeta } from "/home/bede/bede-web/pages/om-oss.vue?macro=true";
import { default as medlemskapcEHsULr3RJO7dwm7IV2eS16K0kOPxHFtx0XaArTeCd4Meta } from "/home/bede/bede-web/pages/medlemskap.vue?macro=true";
import { default as aktiviteter_45HwfM4SCb5FMEBfDcBcgj5SdsatYPHPcn1kbxGFDjdMMeta } from "/home/bede/bede-web/pages/aktiviteter.vue?macro=true";
import { default as givertjenesteVa4j_45SLD1EsD8wlrPw4h5_1ymY3j4Bdf0ZyVP1pkwXcMeta } from "/home/bede/bede-web/pages/givertjeneste.vue?macro=true";
import { default as index3NGNgXWt_HExLx1a0TwlgJLoOy4TFb8JeoyLGm7nKCYMeta } from "/home/bede/bede-web/pages/program/index.vue?macro=true";
import { default as index01Vnymj1DX7n9bx7couC8XrKGWa_45S0e0ibdy1CvV5fgMeta } from "/home/bede/bede-web/pages/vuefire/index.vue?macro=true";
import { default as loginH92u8uNyYrVf_45e8bYtEQ6iog5gsb3VaQakA02FXcTREMeta } from "/home/bede/bede-web/pages/vuefire/login.vue?macro=true";
import { default as usersSYM_3RiWn7LF7qfy8R_OT2Zd0NCk_OfE_454nFgWPylXIMeta } from "/home/bede/bede-web/pages/vuefire/users.vue?macro=true";
import { default as _91event_931BVZIrPWmpOS35SYCt_d0fC_45ESrmPhShEX5sKjZjl5sMeta } from "/home/bede/bede-web/pages/program/[event].vue?macro=true";
import { default as counterIFzUxNakTgPbbQ1s6LB9PttA5o4ryttnae01QTgeMV8Meta } from "/home/bede/bede-web/pages/vuefire/counter.vue?macro=true";
import { default as storageQN63R2ggdk7nkGJERxl3l9XBe_45RF_45SSxuetXOoOqh8EMeta } from "/home/bede/bede-web/pages/vuefire/storage.vue?macro=true";
import { default as _91event_93eZ_45S9ELsdwhwhjy5e7j4ftNO9T0eFtpJHpCFiJTJQ8gMeta } from "/home/bede/bede-web/pages/calendar/[event].vue?macro=true";
import { default as legg_45til_45kalenderIGaR7vuLkfBEV4PJwKjEZa9S8s0WBObr8Hc3VtnRtwUMeta } from "/home/bede/bede-web/pages/legg-til-kalender.vue?macro=true";
import { default as analyticsHfp6QBNYxcuhOrDtuHhELn_45FX8UNY8pv8B__45jNlxLbYMeta } from "/home/bede/bede-web/pages/vuefire/analytics.vue?macro=true";
import { default as app_45checkROPp66yYzomBpFjFhQLFuR_dvdBaaotVPR08xo7itkIMeta } from "/home/bede/bede-web/pages/vuefire/app-check.vue?macro=true";
import { default as newq3Cubg8lhDbGc_45TaQQoCzxu4cWwPeYxY8XIsrdfpiyUMeta } from "/home/bede/bede-web/pages/vuefire/posts/new.vue?macro=true";
import { default as personvernnyke1mKRvTA24IwDAq1EW8hni83AnEROwCPDn0ZX3cgMeta } from "/home/bede/bede-web/pages/juridisk/personvern.vue?macro=true";
import { default as emoji_45panelPa3mpt4MZRUTECsrTgTXa1Ob1QUT6Mdho8cxvstkTzIMeta } from "/home/bede/bede-web/pages/vuefire/emoji-panel.vue?macro=true";
import { default as bruksvilkaraVUrLT4kmHwSrATIW_fZE8E3DkpuCPPbO16nNjGzZ_45UMeta } from "/home/bede/bede-web/pages/juridisk/bruksvilkar.vue?macro=true";
import { default as database_45todo_45listO6AUYc7_45Ef6WhdJxiu6N6MxnjOKqp6XrsL5mElSH9NAMeta } from "/home/bede/bede-web/pages/vuefire/database-todo-list.vue?macro=true";
import { default as informasjonskapslerFZY_FjR3fkoMFZa5HrLrAOUNujgX_45acbuElKjCGZ_45PcMeta } from "/home/bede/bede-web/pages/juridisk/informasjonskapsler.vue?macro=true";
export default [
  {
    name: "kart",
    path: "/kart",
    component: () => import("/home/bede/bede-web/pages/kart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/bede/bede-web/pages/index.vue")
  },
  {
    name: "om-oss",
    path: "/om-oss",
    component: () => import("/home/bede/bede-web/pages/om-oss.vue")
  },
  {
    name: "medlemskap",
    path: "/medlemskap",
    component: () => import("/home/bede/bede-web/pages/medlemskap.vue")
  },
  {
    name: "aktiviteter",
    path: "/aktiviteter",
    component: () => import("/home/bede/bede-web/pages/aktiviteter.vue")
  },
  {
    name: "givertjeneste",
    path: "/givertjeneste",
    component: () => import("/home/bede/bede-web/pages/givertjeneste.vue")
  },
  {
    name: "program",
    path: "/program",
    component: () => import("/home/bede/bede-web/pages/program/index.vue")
  },
  {
    name: "vuefire",
    path: "/vuefire",
    component: () => import("/home/bede/bede-web/pages/vuefire/index.vue")
  },
  {
    name: "vuefire-login",
    path: "/vuefire/login",
    meta: loginH92u8uNyYrVf_45e8bYtEQ6iog5gsb3VaQakA02FXcTREMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/login.vue")
  },
  {
    name: "vuefire-users",
    path: "/vuefire/users",
    meta: usersSYM_3RiWn7LF7qfy8R_OT2Zd0NCk_OfE_454nFgWPylXIMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/users.vue")
  },
  {
    name: "program-event",
    path: "/program/:event()",
    component: () => import("/home/bede/bede-web/pages/program/[event].vue")
  },
  {
    name: "vuefire-counter",
    path: "/vuefire/counter",
    meta: counterIFzUxNakTgPbbQ1s6LB9PttA5o4ryttnae01QTgeMV8Meta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/counter.vue")
  },
  {
    name: "vuefire-storage",
    path: "/vuefire/storage",
    meta: storageQN63R2ggdk7nkGJERxl3l9XBe_45RF_45SSxuetXOoOqh8EMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/storage.vue")
  },
  {
    name: "calendar-event",
    path: "/calendar/:event()",
    component: () => import("/home/bede/bede-web/pages/calendar/[event].vue")
  },
  {
    name: "legg-til-kalender",
    path: "/legg-til-kalender",
    component: () => import("/home/bede/bede-web/pages/legg-til-kalender.vue")
  },
  {
    name: "vuefire-analytics",
    path: "/vuefire/analytics",
    meta: analyticsHfp6QBNYxcuhOrDtuHhELn_45FX8UNY8pv8B__45jNlxLbYMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/analytics.vue")
  },
  {
    name: "vuefire-app-check",
    path: "/vuefire/app-check",
    meta: app_45checkROPp66yYzomBpFjFhQLFuR_dvdBaaotVPR08xo7itkIMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/app-check.vue")
  },
  {
    name: "vuefire-posts-new",
    path: "/vuefire/posts/new",
    meta: newq3Cubg8lhDbGc_45TaQQoCzxu4cWwPeYxY8XIsrdfpiyUMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/posts/new.vue")
  },
  {
    name: "juridisk-personvern",
    path: "/juridisk/personvern",
    component: () => import("/home/bede/bede-web/pages/juridisk/personvern.vue")
  },
  {
    name: "vuefire-emoji-panel",
    path: "/vuefire/emoji-panel",
    meta: emoji_45panelPa3mpt4MZRUTECsrTgTXa1Ob1QUT6Mdho8cxvstkTzIMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/emoji-panel.vue")
  },
  {
    name: "juridisk-bruksvilkar",
    path: "/juridisk/bruksvilkar",
    component: () => import("/home/bede/bede-web/pages/juridisk/bruksvilkar.vue")
  },
  {
    name: "vuefire-database-todo-list",
    path: "/vuefire/database-todo-list",
    meta: database_45todo_45listO6AUYc7_45Ef6WhdJxiu6N6MxnjOKqp6XrsL5mElSH9NAMeta || {},
    component: () => import("/home/bede/bede-web/pages/vuefire/database-todo-list.vue")
  },
  {
    name: "juridisk-informasjonskapsler",
    path: "/juridisk/informasjonskapsler",
    component: () => import("/home/bede/bede-web/pages/juridisk/informasjonskapsler.vue")
  }
]